import { $api } from 'api/http'
import { IOrder, IOrderReview } from 'api/types/order'
import { IUrlParams } from 'api/types/url-params'

class OrderApiService {
  getOrders({ page, limit = 50 }: IUrlParams) {
    return $api.get<Array<IOrder>>(`/orders_history/${page}/${limit}`)
  }
  setOrderReview(review: IOrderReview) {
    return $api.post('/Order_review', review)
  }
}

export const orderApiService = new OrderApiService()
